import { render, staticRenderFns } from "./Prize_basket.vue?vue&type=template&id=a393586a&scoped=true"
import script from "./Prize_basket.vue?vue&type=script&lang=js"
export * from "./Prize_basket.vue?vue&type=script&lang=js"
import style0 from "./Prize_basket.vue?vue&type=style&index=0&id=a393586a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a393586a",
  null
  
)

export default component.exports